import { GraphQLEnumType } from 'graphql'

export type AttackStatus =
  | 'BLOCKED'
  | 'PROBED'
  | 'EXPLOITED'
  | 'BLOCKED_PERIMETER'
  | 'PROBED_PERIMETER'
  | 'SUSPICIOUS'

export const AttackStatusType = new GraphQLEnumType({
  name: 'AttackStatus',
  description: 'The current attack status for an application',
  values: {
    BLOCKED: {},
    BLOCKED_PERIMETER: {},
    PROBED: {},
    PROBED_PERIMETER: {},
    EXPLOITED: {},
    SUSPICIOUS: {}
  }
})
